var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-text"},[_c('h3',{staticClass:"is-size-3"},[_vm._v(" Halaman yang kamu cari, tidak ditemukan. ")]),_c('p',[_c('a',{attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("Kembali ke halaman psikotes")])])])
}]

export { render, staticRenderFns }